"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = void 0;
exports.isLtr = isLtr;
exports.isWindowDefined = void 0;
exports.mapLegacyToTextVariant = mapLegacyToTextVariant;
exports.mergeRefs = mergeRefs;
exports.nodeIsString = nodeIsString;
exports.pxToInt = void 0;
exports.renderConfigOrCustom = renderConfigOrCustom;
function nodeIsString(node) {
  return node && typeof node.valueOf() === 'string';
}
function renderConfigOrCustom(node, DefaultEl) {
  if (nodeIsString(node)) {
    return DefaultEl;
  }
  return node;
}
var isWindowDefined = exports.isWindowDefined = function isWindowDefined() {
  return typeof window !== 'undefined';
};
var capitalize = exports.capitalize = function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
function isLtr(ref) {
  var direction = 'ltr';
  if (ref.current) {
    direction = window.getComputedStyle(ref.current).direction;
  }
  return direction === 'ltr';
}

/**
 * Merges multiple refs into a single ref callback.
 * The merged ref callback can be used to assign a value to multiple refs simultaneously.
 * Heavily inspired by https://github.com/gregberge/react-merge-refs
 *
 * @template T - The type of the HTML element.
 * @param refs - An array of refs to be merged.
 * @returns A ref callback that assigns a value to all the merged refs.
 */

function mergeRefs(refs) {
  return function (value) {
    refs.forEach(function (ref) {
      if (typeof ref === 'function') {
        ref(value);
      } else if (ref !== null) {
        ref.current = value;
      }
    });
  };
}

/**
 * Helper for converting a token (in string px format) to an integer.
 * @example
 * pxToInt(spacer16) // returns 16
 *  */
var pxToInt = exports.pxToInt = function pxToInt(px) {
  return parseInt(px, 10);
};
var textVariantMapping = {
  bass: 'headlineLarge',
  forte: 'headlineMedium',
  brio: 'titleLarge',
  altoBrio: 'titleLarge',
  alto: 'titleMedium',
  canon: 'titleSmall',
  celloCanon: 'titleSmall',
  cello: 'bodyMediumBold',
  ballad: 'bodyMedium',
  balladBold: 'bodyMediumBold',
  viola: 'bodySmall',
  violaBold: 'bodySmallBold',
  mesto: 'bodySmall',
  mestoBold: 'bodySmallBold',
  finale: 'marginal',
  finaleBold: 'marginalBold',
  // variants below aren't 1:1 so we're mapping to the variant that preserves visual space (they've also been deprecated for ~5 years)
  // https://www.figma.com/proto/KzUo98tnaOuGXNg3rrcYB8/Font-requests?page-id=2205%3A4688&node-id=2646-5935&viewport=409%2C106%2C0.05&scaling=min-zoom&starting-point-node-id=2645%3A5754
  metronome: 'bodySmallBold',
  minuet: 'marginal',
  minuetBold: 'marginalBold'
};

/** Variant map used if the weight prop (deprecated) is used to request a bold or black weight. */
var textVariantMappingWithBold = {
  cello: 'bodyMediumBold',
  ballad: 'bodyMediumBold',
  viola: 'bodySmallBold',
  mesto: 'bodySmallBold',
  finale: 'marginalBold',
  metronome: 'bodySmallBold',
  minuet: 'marginalBold'
};

/** Takes a legacy Type variant and and weight returns the equivalent Text variant */
function mapLegacyToTextVariant(variant, weight) {
  // If the variant is a valid Text variant, return it (we ignore the `weight` prop in this case).
  if (Object.values(textVariantMapping).includes(variant)) {
    return variant;
  }
  // Logic for handling the `weight` prop:
  // - weight="bold" or "black" are treated the same, we map to the bold or black variant at the same font size
  // - No weight or weight="book" -> return the new variant mapping
  if ((weight === 'black' || weight === 'bold') && Object.keys(textVariantMappingWithBold).includes(variant)) {
    return textVariantMappingWithBold[variant];
  }
  return textVariantMapping[variant];
}